export default __webpack_public_path__ + "static/media/error.7cb3aebf.svg";